import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Flex, Text, Image } from 'atoms';
import MyCollection from 'assets/my-collection.svg';
import CollectionSent from 'assets/collection-sent.svg';
import CollectionReceived from 'assets/collection-received.svg';

const InvoiceCount = styled.span`
	font-size: 12px;
	font-weight: 400;
	line-height: 14px;
	margin: 0 0.3rem;
`;

const getImage = (title) => {
	switch (title) {
		case 'My Collections':
			return MyCollection;
		case 'Sent':
			return CollectionSent;
		case 'Received':
			return CollectionReceived;
		default:
			return '';
	}
};

export default function AccordionHeader({ title, invoiceCount = 0 }) {
	return (
		<Flex flex={1} justifyContent="space-between" alignItems="center" alignSelf="center">
			<Flex alignItems="center">
				<Image src={getImage(title)} alt={title} />
				<Text ml={1} fontFamily="Roboto" fontSize="11px" fontWeight="300" color="#fff">
					{title}
				</Text>
			</Flex>
			<Text fontFamily="Roboto" fontSize="8px" fontWeight="300" color="#fff" marignLeft="5px">
				Total Invoice :<InvoiceCount>{invoiceCount}</InvoiceCount>
			</Text>
		</Flex>
	);
}

AccordionHeader.propTypes = {
	title: PropTypes.string,
	invoiceCount: PropTypes.number,
};
